import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";
import { APP_LANGUAGE_DEFINITIONS } from "@/localization/languages";

const SUPPORTED_LOCALES = APP_LANGUAGE_DEFINITIONS.map((language) => ({
  code: language.locale,
  name: language.nativeName,
  flag: language.flag,
}));

interface LanguageSelectorProps {
  value?: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

export function LanguageSelector({ 
  value, 
  onChange, 
  className,
  placeholder = "Select language..." 
}: LanguageSelectorProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Globe className="h-4 w-4 text-muted-foreground" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="min-w-[160px]">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {SUPPORTED_LOCALES.map((locale) => (
            <SelectItem key={locale.code} value={locale.code}>
              <span className="flex items-center gap-2">
                <span>{locale.flag}</span>
                <span>{locale.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export { SUPPORTED_LOCALES };
